import React from 'react';

import { BodyText } from '@garnish/core';

import { styles } from '../TextField.styles';

export const TextFieldHelperText = (props: React.ComponentProps<typeof BodyText>) => {
  const { children, ...restProps } = props;

  if (!children) return null;

  return (
    <BodyText sizeMatch={['12']} style={styles.helperText} {...restProps}>
      {children}
    </BodyText>
  );
};
